import PropTypes from 'prop-types'
import { createContext, useContext, useEffect, useMemo, useState } from 'react'

// Crea un contexto para gestionar el estado del usuario actual
export const AuthContext = createContext(null)

// Proveedor del contexto del usuario actual. Envuelve los componentes hijos y proporciona las funciones para manejar el usuario actual
export const AuthProvider = ({ children }) => {
  // Estado para el usuario actual, inicializado desde localStorage si existe
  const initialToken = useMemo(() => {
    const storedToken = localStorage.getItem('token')
    return storedToken && storedToken !== 'undefined'
      ? JSON.parse(storedToken)
      : null
  }, [])

  const [token, setToken] = useState(initialToken)

  // Guarda el estado del usuario en localStorage cada vez que este cambia
  useEffect(() => {
    if (token !== null) {
      localStorage.setItem('token', JSON.stringify(token))
    } else {
      localStorage.removeItem('token')
    }
  }, [token])

  const contextValue = useMemo(() => ({ token, setToken }), [token])

  return (
    // Proporciona el estado y las funciones del usuario actual a los componentes hijos
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}

// Hook personalizado para usar el contexto del usuario actual de forma más sencilla
export const useAuth = () => useContext(AuthContext)

AuthProvider.propTypes = {
  children: PropTypes.any
}
